'use client'

import { useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './ProductSwiper.module.css'

import 'swiper/css'
import 'swiper/css/navigation'

export default function ProductSwiper({
  product,
  productUrl,
  navKey,
  priority = false,
  unoptimized = false,
  imageClassName = '',
}) {
  const [imageTypeMap, setImageTypeMap] = useState({})

  const pictures = Array.isArray(product?.PictureData)
    ? product.PictureData
    : []

  const images = pictures
    .map((p) => p?.PicturePath || p?.Url || p?.Path || p?.Name)
    .filter(Boolean)

  const finalImages = images.length
    ? images
    : ['/images/placeholder/placeholder-600.png']

  const alt = product?.ProductName || `product-${product?.ProductID || navKey}`

  const prevClass = `product-img-prev-${navKey}`
  const nextClass = `product-img-next-${navKey}`

  const handleImageLoad = (img, src) => {
    const width = img.naturalWidth
    const height = img.naturalHeight

    if (!width || !height) return

    const ratio = width / height

    let type = 'portrait'

    // 接近正方形
    if (ratio >= 0.85 && ratio <= 1.15) {
      type = 'square'
    }

    // 橫圖
    if (ratio > 1.15) {
      type = 'wide'
    }

    // 直圖
    if (ratio < 0.85) {
      type = 'portrait'
    }

    setImageTypeMap((prev) => ({
      ...prev,
      [src]: type,
    }))
  }

  return (
    <div className={styles.swiperBox}>
      <Swiper
        modules={[Navigation]}
        slidesPerView={1}
        navigation={{
          prevEl: `.${prevClass}`,
          nextEl: `.${nextClass}`,
        }}
        className={styles.productSwiper}
      >
        {finalImages.map((src, index) => {
          const imageType = imageTypeMap[src] || 'portrait'

          return (
            <SwiperSlide key={`${src}-${index}`} className={styles.slide}>
              <Link href={productUrl} className={styles.imageLink}>
                <div className={styles.imageBox}>
                  <Image
                    src={src}
                    alt={alt}
                    fill
                    unoptimized={unoptimized}
                    priority={priority && index === 0}
                    className={`
                      ${styles.img}
                      ${imageType === 'square' ? styles.squareImg : ''}
                      ${imageType === 'wide' ? styles.wideImg : ''}
                      ${imageType === 'portrait' ? styles.portraitImg : ''}
                      ${imageClassName}
                    `}
                    sizes="(max-width: 576px) 100vw, (max-width: 992px) 50vw, 25vw"
                    onLoad={(e) => handleImageLoad(e.currentTarget, src)}
                  />
                </div>
              </Link>
            </SwiperSlide>
          )
        })}

        {finalImages.length > 1 && (
          <>
            <button
              type="button"
              className={`${styles.navBtn} ${styles.prevBtn} ${prevClass}`}
              aria-label="上一張"
            >
              ‹
            </button>

            <button
              type="button"
              className={`${styles.navBtn} ${styles.nextBtn} ${nextClass}`}
              aria-label="下一張"
            >
              ›
            </button>
          </>
        )}
      </Swiper>
    </div>
  )
}
